import {
  ImageScaleView,
  ImageScaleViewOpts,
  MovieClip,
} from '@play-co/timestep-core/ui';

/**
 * Utility for playing a sequence of animations on a MovieClip
 * @param args
 */
export async function playAnimationSequence(args: {
  movieclip: MovieClip;
  animations: string[];
  loopLast?: boolean;
}) {
  const { movieclip, animations, loopLast } = args;
  // Play all animations but the last, in sequence
  const allAnimsButLast = animations.slice(0, -1);
  for (const anim of allAnimsButLast) {
    await movieclip.playAsync(anim);
  }
  // Play last animation, not awaiting if last animation should loop
  const lastAnim = animations[animations.length - 1];
  if (loopLast) {
    movieclip.play(lastAnim, null, true);
  } else {
    await movieclip.playAsync(lastAnim);
  }
}

export type FrameByFrameClipOpts = ImageScaleViewOpts & {
  frames: string[];
  rate?: number;
};

/**
 * A view that cycles through a list of images at a fixed rate.
 */
export class FrameByFrameClip extends ImageScaleView {
  private readonly frames: string[];
  private readonly rate: number;
  private index = 0;
  private timer = 0;

  constructor(opts: FrameByFrameClipOpts) {
    super(opts);
    this.frames = opts.frames;
    this.rate = opts.rate ?? 1;
  }

  public tick(dt: number) {
    this.timer += dt;
    if (this.timer >= this.rate) {
      this.timer -= this.rate;
      this.index = (this.index + 1) % this.frames.length;
      this.setImage(this.frames[this.index]);
    }
  }
}
